export default __webpack_public_path__ + "static/media/logo_sentosa.29bc49a5.png";